import { render, staticRenderFns } from "./shopList.vue?vue&type=template&id=21fc1fe6&scoped=true"
import script from "./shopList.vue?vue&type=script&lang=js"
export * from "./shopList.vue?vue&type=script&lang=js"
import style0 from "./shopList.vue?vue&type=style&index=0&id=21fc1fe6&prod&scoped=true&lang=css"
import style1 from "./shopList.vue?vue&type=style&index=1&id=21fc1fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc1fe6",
  null
  
)

export default component.exports